import React, { useContext, useState } from 'react';
import { array, func, object, string } from 'prop-types';
import style from './Hero.module.scss';
import LangContext from '@contexts';
import { langPath } from '@helpers';
import SearchInput from '../../../../components/SearchInput/SearchInput';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import FilterImage from './Image/filter.png';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';

const Hero = ({
  articles,
  isCategory,
  handleInputChange,
  categoryEdges,
  lang,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const currentLang = useContext(LangContext);
  const location = useLocation();

  let tagList = [];
  let categoryList = [];

  articles.forEach(({ node }) => {
    tagList = [...tagList, ...node.tags];
  });
  const uniqTagList = [...new Set(tagList)];

  if (categoryEdges.length > 0) {
    categoryEdges.forEach(({ node }) => {
      const existingCategory = categoryList.find(
        (category) =>
          category.data.category_name.text === node.data.category_name.text
      );
      if (
        !existingCategory &&
        uniqTagList.includes(node?.data?.category_name?.text)
      ) {
        categoryList.push(node);
      }
    });
  }

  const categoryTypes = categoryList.map(
    (node) => node.data.category_type.text
  );
  const uniqueCategoryTypes = [...new Set(categoryTypes)];

  const regulationCategory = categoryList.filter(
    (node) => node?.data?.category_type?.text === 'Regulations'
  );
  const dataPrivacyCategory = categoryList.filter(
    (node) => node?.data?.category_type?.text === 'Data Privacy'
  );

  return (
    <section className={style.hero}>
      <div
        className={`${style.title} ${
          isCategory && isCategory.type === 'category' && style.category
        }`}
      >
        <div className={style.blogsearch}>
          <div className={style.search}>
            <SearchInput
              onChange={(e) => {
                handleInputChange(e.target.value);
              }}
              placeholder={{ text: 'Search' }}
            />
          </div>
        </div>

        <Accordion
          className={style.accordion}
          allowZeroExpanded
          allowMultipleExpanded
          preExpanded={['a']}
        >
          <AccordionItem className={style.accordionItem} uuid="a">
            <AccordionItemHeading className={style.accordionItemHeading}>
              <AccordionItemButton className={style.accordionItemButton}>
                <p>{uniqueCategoryTypes[0]}</p>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={style.accordionItemPanel}>
              {regulationCategory
                ?.sort((a, b) =>
                  a.data.category_name.text.localeCompare(
                    b.data.category_name.text
                  )
                )
                ?.map((item, index) => {
                  return (
                    <Link
                      to={`${langPath(
                        currentLang
                      )}/${item.data.category_name.text
                        .replace(/\W+/g, '-')
                        .toLowerCase()}`}
                      className={`${style.accordionItemPanelItem} ${
                        location.pathname ===
                        `${langPath(
                          currentLang
                        )}/${item.data.category_name.text
                          .replace(/\W+/g, '-')
                          .toLowerCase()}`
                          ? style.active
                          : ''
                      }`}
                      key={`${item}${index}`}
                    >
                      {item.data.category_name.text}
                    </Link>
                  );
                })}
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>

        <Accordion
          className={style.accordion}
          allowZeroExpanded
          allowMultipleExpanded
          preExpanded={['b']}
        >
          <AccordionItem className={style.accordionItem} uuid="b">
            <AccordionItemHeading className={style.accordionItemHeading}>
              <AccordionItemButton className={style.accordionItemButton}>
                <p>{uniqueCategoryTypes[1]}</p>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={style.accordionItemPanel}>
              {dataPrivacyCategory
                .sort((a, b) =>
                  a.data.category_name.text.localeCompare(
                    b.data.category_name.text
                  )
                )
                ?.map((item, index) => {
                  return (
                    <Link
                      to={`${langPath(
                        currentLang
                      )}/${item.data.category_name.text
                        .replace(/\W+/g, '-')
                        .toLowerCase()}`}
                      className={`${style.accordionItemPanelItem} ${
                        location.pathname ===
                        `${langPath(
                          currentLang
                        )}/${item.data.category_name.text
                          .replace(/\W+/g, '-')
                          .toLowerCase()}`
                          ? style.active
                          : ''
                      }`}
                      key={`${item}${index}`}
                    >
                      {item.data.category_name.text}
                    </Link>
                  );
                })}
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <div className={style.filter} onClick={() => setIsVisible(true)}>
          <img
            src={FilterImage}
            className={style.filterImage}
            alt="filter"
            width={44}
            height={44}
          />
        </div>

        <div
          className={isVisible ? style.filterIconVisible : style.filterIconHide}
          onMouseLeave={() => setIsVisible(false)}
        >
          <Accordion
            className={style.accordionforMobile}
            allowZeroExpanded
            allowMultipleExpanded
            preExpanded={['a']}
          >
            <AccordionItem className={style.accordionItem} uuid={'a'}>
              <AccordionItemHeading className={style.accordionItemHeading}>
                <AccordionItemButton className={style.accordionItemButton}>
                  <p>{uniqueCategoryTypes[0]}</p>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className={style.accordionItemPanelforMobile}>
                {regulationCategory
                  ?.sort((a, b) =>
                    a.data.category_name.text.localeCompare(
                      b.data.category_name.text
                    )
                  )
                  ?.map((item, index) => {
                    return (
                      <Link
                        to={`${langPath(
                          currentLang
                        )}/${item.data.category_name.text
                          .replace(/\W+/g, '-')
                          .toLowerCase()}`}
                        className={style.accordionItemPanelItem}
                        key={`${item}${index}`}
                      >
                        {item.data.category_name.text}
                      </Link>
                    );
                  })}
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion
            className={style.accordionforMobile}
            allowZeroExpanded
            allowMultipleExpanded
            preExpanded={['b']}
          >
            <AccordionItem className={style.accordionItem} uuid={'b'}>
              <AccordionItemHeading className={style.accordionItemHeading}>
                <AccordionItemButton className={style.accordionItemButton}>
                  <p>{uniqueCategoryTypes[1]}</p>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className={style.accordionItemPanelforMobile}>
                {dataPrivacyCategory
                  .sort((a, b) =>
                    a.data.category_name.text.localeCompare(
                      b.data.category_name.text
                    )
                  )
                  ?.map((item, index) => {
                    return (
                      <Link
                        to={`${langPath(
                          currentLang
                        )}/${item.data.category_name.text
                          .replace(/\W+/g, '-')
                          .toLowerCase()}`}
                        className={style.accordionItemPanelItem}
                        key={`${item}${index}`}
                      >
                        {item.data.category_name.text}
                      </Link>
                    );
                  })}
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  articles: array,
  title: object,
  buttontext: array,
  isCategory: object,
  handleInputChange: func,
  handleSearchInputChange: func,
  categoryEdges: array,
  lang: string,
};

export default Hero;
